import React, { useEffect, useState } from "react";
import { useSetState } from "Helpers/Hooks";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import { read } from "Helpers/LocalStorage";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import { Chip } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import { satc_paymentDetailsColumn } from "Constants/TableColumns";
import * as R from "ramda";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import addNumToList from "Helpers/addNumToList";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";
import RemoteTable from "Components/RemoteTable/RemoteTable";

export default function AddUser({
  row,
  onAddUser,
  getAgain,
  changeGetAgain,
  seterCredit,
}) {
  const { t } = useTranslation();
  const [formValid, setFormValid] = useState({});
  const [change, setChange] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [priceCalc, setPriceCalc] = useState(false);
  const [priceCalcLoading, setPriceCalcLoading] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [credit, setCredit] = useState(0);
  const [controls, setControls] = useSetState({
    normalUserCount: {
      type: "number",
      value: 0,
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
      },
    },
    nazerUserCount: {
      type: "number",
      value: 0,
      validation: {
        required: true,
        isNumeric: true,
        min: 0,
      },
    },
    discount: {
      type: "text",
      value: null,
      validation: null,
    },
  });

  useEffect(() => {
    setFormValid({ normalUserCount: true, nazerUserCount: true });
    setCheckValid(false);
    setControls({ discount: { value: "" } });
    setControls({ normalUserCount: { value: "0" } });
    setControls({ nazerUserCount: { value: "0" } });
  }, []);

  const priceCalcfunc = async (e) => {
    e?.preventDefault();
    setPriceCalc(false);
    setPriceCalcLoading(true);
    try {
      const { normalUserCount, nazerUserCount, discount } = controls;
      const nuc = +convertToEnglishNumber(normalUserCount.value);
      const suc = +convertToEnglishNumber(nazerUserCount.value);
      if (nuc !== 0 || suc !== 0) {
        if (
          !R.isEmpty(formValid) &&
          Object.values(formValid).every((item) => item === true)
        ) {
          const data = {
            KeyGroup: read("groupAKey"),
            KeyUser: read("userAKey"),
            GroupId: row.Id,
            Count: nuc,
            DiscountCode: discount.value,
            CountSuperVisor: suc,
          };
          const response = await AccountService.postUpgradeCalculate(data);
          let err = StatusHandler(response);
          if (!err.isFail) {
            setPaymentData(response.data.Value.Detail);
            const credit_response = await AccountService.getAccountGroupInfo({
              KeyGroup: read("groupAKey"),
              KeyUser: read("userAKey"),
              GroupId: row.Id,
            });
            if (!StatusHandler(credit_response).isFail) {
              setCredit(credit_response.data.Value.Credit);
              seterCredit(credit_response.data.Value.Credit);
            }
            setChange(false);
            setPriceCalc(true);
            setPriceCalcLoading(false);
          } else {
            setChange(false);
            setPriceCalc(false);
            setPriceCalcLoading(false);
          }
        } else {
          setChange(true);
          setPriceCalc(false);
          setPriceCalcLoading(false);
          showNotify({
            text: t("correctFormDataRequired"),
            customClass: "error",
          });
        }
      } else {
        setChange(true);
        setPriceCalc(false);
        setPriceCalcLoading(false);
        showNotify({ text: t("noDataInIncreaseUser"), customClass: "error" });
      }
    } catch {
      setChange(true);
      setPriceCalc(false);
      setPriceCalcLoading(false);
    }
  };

  useEffect(() => {
    if (getAgain === 1) {
      setPriceCalcLoading(true);
      setPriceCalc(false);
    } else if (getAgain === 2) {
      priceCalcfunc(null);
      changeGetAgain();
    }
  }, [getAgain]);

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
    setChange(true);
  };

  useEffect(() => {
    if (priceCalc && !change) {
      const { normalUserCount, nazerUserCount, discount } = controls;
      const nuc = +convertToEnglishNumber(normalUserCount.value);
      const suc = +convertToEnglishNumber(nazerUserCount.value);
      if (nuc !== 0 || suc !== 0) {
        if (
          !R.isEmpty(formValid) &&
          Object.values(formValid).every((item) => item === true)
        ) {
          onAddUser({
            changeActive: true,
            nuc,
            suc,
            priceShow: paymentData.PriceShow,
            discount: discount.value,
          });
        } else {
          showNotify({ text: t("noDataInIncreaseUser"), customClass: "error" });
          setPriceCalc(false);
          setPriceCalcLoading(false);
          onAddUser({ changeActive: false });
        }
      }
    } else {
      onAddUser({ changeActive: false });
    }
  }, [priceCalc, change]);

  return (
    <Grid container spacing={1}>
      {Object.keys(controls).map((key) => {
        return (
          <Grid item key={key} md={3} sm={6} xs={12}>
            {controls[key].type === "text" && (
              <Input
                setValue={setValue.bind(this)}
                name={key}
                validation={controls[key].validation}
                placeholder={t(key)}
                label={<Translator id={key} />}
                type="text"
                checkValid={checkValid}
                value={controls[key].value}
              />
            )}
            {controls[key].type === "number" && (
              <Input
                setValue={setValue.bind(this)}
                name={key}
                defaultValue={controls[key].value}
                validation={controls[key].validation}
                label={<Translator id={key} />}
                type="text"
                checkValid={checkValid}
                value={controls[key].value}
              />
            )}
          </Grid>
        );
      })}
      <Grid item md={3} sm={6} xs={12} className="d-flex align-items-center">
        <MuiButton
          color="primary"
          title={<Translator id="priceCalculation" />}
          onClick={priceCalcfunc}
          loading={priceCalcLoading}
          disabled={!change}
          fullwidthOnSm
        />
      </Grid>
      {priceCalc && (
        <Grid container spacing={2} className="mt-3">
          <Grid item xs={12}>
            <RemoteTable
              data={addNumToList(paymentData.Items)}
              columns={satc_paymentDetailsColumn}
              showPagination={false}
            />
          </Grid>
          <Grid item xs={12} className="paymentSection">
            <p>
              <Chip label={t("totalAmounts")} />
              <strong>{paymentData.PriceCalcList.toLocaleString()}</strong>
              <Translator id="moneyUnit" />
            </p>
            <p>
              <Chip label={t("userIncreaseDetailDiscount")} />
              <strong>{paymentData.DiscountCalcPrice.toLocaleString()}</strong>
              <Translator id="moneyUnit" />
            </p>
            <p>
              <Chip label={t("userIncreaseDetailPriceShow")} />
              <strong>{paymentData.PriceShow.toLocaleString()}</strong>
              <Translator id="moneyUnit" />
            </p>
            <p className="credit-show">
              <Translator id="priceCredit" />
              <strong>{credit.toLocaleString()}</strong>
              <Translator id="moneyUnit" />
            </p>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
